import { gql } from "@apollo/client";

const TENNIS_STATS = gql`
  query fixture($id: ID!) {
    fixture(id: $id) {
      id
      placements {
        id
        value
        profile {
          id
          name
        }
      }
      event {
        id
        sport {
          id
          name
          statTypes {
            id
            name
          }
        }
      }
      statsSummary {
        participantId
        tennisPointsWon
        tennisServes
        tennisServesWon
        tennisDoubleFaults
        tennisUnforcedErrors
        tennisAces
      }
      stats {
        id
        createdAt
        timeStamp
        value
        stringValue
        statType {
          id
          name
        }
        profile {
          id
          name
        }
        organization {
          id
          name
        }
        fixturePeriod {
          id
          order
          label
        }
        relationshipsFrom {
          id
          to {
            id
            createdAt
            stringValue
            value
            timeStamp
            statType {
              id
              name
            }
            profile {
              id
              name
            }
            organization {
              id
              name
            }
            fixturePeriod {
              id
              label
            }
          }
        }
        relationshipsTo {
          id
          from {
            id
            createdAt
            stringValue
            value
            timeStamp
            statType {
              id
              name
            }
            profile {
              id
              name
            }
            organization {
              id
              name
            }
            fixturePeriod {
              id
              label
            }
          }
        }
      }
    }
  }
`;

export default TENNIS_STATS;
